import React from 'react'
import Styles from './TerminarTrabajoUnidades.module.css'
import {Form, Input, Button} from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'

class TerminarTrabajoUnidad extends React.Component{
	constructor(props){
		super(props)
		this.state={
			trabajo:props.trabajo,
            mensajes:{
                unidades:false,
            }
        }
    }
    handleChange=(e, {value})=>{
        const state= this.state
        state.trabajo.trabajoHecho=value
        state.trabajo.precio=+(value* this.state.trabajo.precioUnitario).toFixed(2)
        this.setState(state)
    }
    handleSubmit=(event)=>{
        event.preventDefault()
        if(this.state.trabajo.trabajoHecho===0){
            const mensajes=this.state.mensajes
            mensajes.unidades=true
            this.setState({mensajes:mensajes})
            return null
        }
        const batch=firebase.firestore().batch()
        const pagos=firebase.firestore().collection('Pagos')
        const trabajo=this.state.trabajo
        batch.update(firebase.firestore().collection('TareasAsignadas').doc(trabajo.trabajoID),{
            estado:"completado", 
            precioUnitario:this.state.trabajo.precioUnitario,
            longitudTrabajo:Number(this.state.trabajo.trabajoHecho),
            precioTotal:this.state.trabajo.precio,
            fechaCompletado:new Date()
        })
        if(!trabajo.nomina || trabajo.nomina==='tarea'){
            for(let i=0; i<trabajo.empleados.length; i++){
                batch.set(pagos.doc(), {
                    trabajoId:trabajo.trabajoID,
                    empleado:trabajo.empleados[i],
                    nombreActividad:trabajo.nombreActividad,
                    descripcion:trabajo.descripcion,
                    trabajoHecho:Number(trabajo.trabajoHecho),
                    dificultad:trabajo.dificultad,
                    unidades:'unidades',
                    precio:trabajo.precio,
                    areaHecha:trabajo.area,
                    numInvolucrados:trabajo.empleados.length,
                    fecha:new Date(),
                    estado:'pendiente'				
                })
            }
        }
		batch.commit()
        .then(()=>{
		})
		.catch(e=>{
			alert(e)
		})
    }
	render(){
		return(
			<section>
				<Form onSubmit={this.handleSubmit}>
                    <div className={Styles.Inputs}>
                        <div className={Styles.Input}>
                            <p>Unidades completadas: </p>
                            <Input type='number' value={this.state.trabajo.trabajoHecho} onChange={this.handleChange}></Input>
                            {
                                this.state.mensajes.unidades?
                                <p className={Styles.message}>Campo Obligatorio</p>
                                :null
                            }
                        </div>
                        <div className={Styles.Input}>
                            <p>precioUnitario</p>
                            <Input value={this.state.trabajo.precioUnitario} disabled></Input>
                        </div>
                        <div className={Styles.Input}>
                            <p>Total</p>
                            <Input value={this.state.trabajo.precio} disabled></Input>
                        </div>
                    </div>
                    <Button type='submit'>Completar</Button>
				</Form>
			</section>
		)
	}
}
export default TerminarTrabajoUnidad